/**
 * Regex pattern for YYYY-MM-DD or YYYY/MM/DD
 * Supports leap year and restricts dates in month of Feb as well.
 * https://stackoverflow.com/a/64222248
 * */
export const DATE_REGEX_STRING =
  '(((19|20)([2468][048]|[13579][26]|0[48])|2000)[/-]02[/-]29|((19|20)[0-9]{2}[/-](0[469]|11)[/-](0[1-9]|[12][0-9]|30)|(19|20)[0-9]{2}[/-](0[13578]|1[02])[/-](0[1-9]|[12][0-9]|3[01])|(19|20)[0-9]{2}[/-]02[/-](0[1-9]|1[0-9]|2[0-8])))';

const MAX_ALLOWED_DAYS = 365;

export const getMaxUTCDateString = (
  currentDate: string,
  daysToAdd = MAX_ALLOWED_DAYS
) => {
  const date = new Date(currentDate);
  date.setDate(date.getDate() + daysToAdd);

  return date.toLocaleDateString('en-CA', { timeZone: 'UTC' });
};

export const formatDateUTC = (date: Date): string => {
  const month = date.toLocaleString('en-US', {
    month: 'short',
    timeZone: 'UTC'
  });

  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();

  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  return `${month} ${day}, ${year}, ${hours}:${minutes} UTC`;
};
